import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import CardMedia from '@mui/material/CardMedia';

// import p1 from 'assests/Photos/Clubs/EkBharatClub/ek-bharat.jpg';
// import p2 from 'assests/Photos/Clubs/Commerce.jpg';





const Features = ()=> {

  const [config, setConfig] = useState({ base_image_url: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url}/home/home-static/static-images/all-static-images/Clubs/EkBharatClub/ek-bharat.webp`;
  const p2 = `${config.base_image_url}/home/home-static/static-images/all-static-images/Clubs/Commerce.webp`;
  


  const theme = useTheme();
  const { mode } = theme.palette;
  
const mock = [
  {
    media: 'https://i.imgur.com/tI4USNm.jpg',
    href: '/sportsclub',
    companyLogo:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/Sport_Club_Internacional_1909_Crest.svg/512px-Sport_Club_Internacional_1909_Crest.svg.png?20210206213852',
    description:
      'Sport',
  },
  // {
  //   media: 'https://i.imgur.com/hyWxeqD.png',
  //   href: '/art-club',
  //   companyLogo:
  //     'https://www.seekpng.com/png/full/360-3609883_art-club.png',
  //   description:
  //     'Art',
  // },
  // {
  //   media: 'https://thumbs.dreamstime.com/z/music-club-logo-illustration-you-can-used-your-design-your-bar-many-more-bussines-entertainment-67814384.jpg',
  //   href: '/music-club',
  //   companyLogo:
  //     'https://previews.123rf.com/images/koksikoks/koksikoks1610/koksikoks161000499/64320860-music-club-vintage-emblems-in-black-and-white.jpg',
  //   description:
  //     'Music',
  // },
  {
    media: 'https://www.svgrepo.com/show/61264/science.svg',
    href: '/song-spoof-2023',
    companyLogo:
      'https://www.svgrepo.com/show/61264/science.svg',
    description:
      'Science',
  },
  {
    media: 'https://i.imgur.com/hvzPwnc.png',
    href: '/treasure-hunt-2023',
    companyLogo:
      'https://www.svgrepo.com/show/116135/mathematical-symbols-in-four-squares.svg',
    description:
      'Math',
  },
  {
    media: 'https://i.imgur.com/cVhGAkw.png',
    href: '/Inquizitive-2023',
    companyLogo:
      'https://st2.depositphotos.com/1915171/6207/v/950/depositphotos_62072697-stock-illustration-quiz-icon.jpg?forcejpeg=true',
    description:
      'Quiz',
  },
  {
    media: 'https://1.bp.blogspot.com/-GFVSU2IMPTs/YDzP0jUblgI/AAAAAAAABYU/biaHILeEviInZz1OF_9mL2MAzBSzM5s_gCLcBGAsYHQ/s320/WhatsApp%2BImage%2B2021-02-14%2Bat%2B10.30.31%2BPM.jpeg',
    href: '/art-leaf-2024',
    companyLogo:
      'https://www.svgrepo.com/show/118643/eco-leaf.svg',
    description:
      'Eco',
  },
  
  {
    media: 'https://i.imgur.com/MrJ1hZQ.png',
    href: '/inhouse-mun-2024',
    companyLogo:
      'https://i.imgur.com/Z8HU8S9.jpg',
    description:
      'Humanity',
  },
  {
    media: 'https://i.imgur.com/tau1RwO.png',
    href: '/library-management-2023',
    companyLogo:
      'https://i.imgur.com/zSTHF6H.png',
    description:
      'Cyber',
  },
  {
    media: 'https://i.pinimg.com/originals/73/29/ec/7329ec81dcceead61217a205c941a3b3.jpg',
    href: '/dengue-prevention',
    companyLogo:
      'https://i.pinimg.com/originals/73/29/ec/7329ec81dcceead61217a205c941a3b3.jpg',
    description:
      'Health & Wellness Club',
  },
  {
    media: 'https://c8.alamy.com/comp/2BNPJW2/creative-tree-logo-and-icon-vector-template-2BNPJW2.jpg',
    href: '/integrity-heritage-club',
    companyLogo:
      'https://c8.alamy.com/comp/2BNPJW2/creative-tree-logo-and-icon-vector-template-2BNPJW2.jpg',
    description:
      'Integrity & Heritage Club',
  },
  {
    media: 'https://cdn2.vectorstock.com/i/1000x1000/63/41/book-icon-logo-design-vector-28056341.jpg',
    href: '/reading-day-2025',
    companyLogo:
      'https://cdn2.vectorstock.com/i/1000x1000/63/41/book-icon-logo-design-vector-28056341.jpg',
    description:
      'Reading Club',
  },
  {
    media: 'https://i.pinimg.com/564x/1d/f8/7a/1df87a7304f898b926ed8903847ab798.jpg',
    href: '/pick-and-speak-2024',
    companyLogo:
      'https://i.pinimg.com/564x/1d/f8/7a/1df87a7304f898b926ed8903847ab798.jpg',
    description:
      'literary club',
  },
  {
    media: p1,
    href: '/ek-bharat-2023',
    companyLogo: p1,
    description:
      'Ek Bharat Shreshta Bharath',
  },

  {
    media: 'https://cdn.vectorstock.com/i/preview-1x/81/64/election-icon-vector-14568164.webp',

    href: '/election-of-class-leaders-2025',
    companyLogo:
      'https://cdn.vectorstock.com/i/preview-1x/81/64/election-icon-vector-14568164.webp',
    description:
      ' Electoral Literacy Club',
  },

  {
    media: p2,

    href: '/mock-stock-2024',
    companyLogo:
    p2,
    description:
      ' Commerce Club',
  }

];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{
            fontWeight: 700 
          }}
          gutterBottom
          // color={'secondary'}
          align={'center'}
          variant={'h4'}
          
        >
          Our Clubs
        </Typography>
        <br />
        {/* <Box
          component={Typography}
          fontWeight={700}
          variant={'h6'}
          align={'center'}
        >
          See how we are involving in 
          <br />
          various activities
        </Box> */}
      </Box>
      <Grid container spacing={4}>
        {mock.map((item, i) => (
          <Grid item xs={12} sm={6} md={4} key={i}>
            <a href={item.href} style={{ textDecoration: 'none', color: 'black' }}>
            <Box
              // component={'a'}
              href={''}
              display={'block'}
              width={1}
              height={1}
              sx={{
                textDecoration: 'none',
                transition: 'all .2s ease-in-out',
                '&:hover': {
                  transform: `translateY(-${theme.spacing(1 / 2)})`,
                },
              }}
            >
              <Box
                component={Card}
                width={1}
                height={1}
                borderRadius={2}
                display={'flex'}
                flexDirection={'column'}
              >
                
                <CardMedia
                  image={item.media}
                  component = 'img'
                  sx={{
                    height: 240,
                  }}
                />
                
                <Box component={CardContent}>
                  <Box maxWidth={100} marginY={2}>
                    <Box
                      component="img"
                      height={1}
                      width={1}
                      src={item.companyLogo}
                      alt="..."
                      sx={{
                        filter: mode === 'dark' ? 'contrast(0)' : 'none',
                      }}
                    />
                  </Box>
                  <Typography
                    variant={'h6'}
                    gutterBottom
                    align={'left'}
                    sx={{ fontWeight: 700 }}
                  >
                    {item.description}
                  </Typography>
                </Box>
                
                <Box flexGrow={1} />
                <Box component={CardActions} justifyContent={'flex-start'}>
                  {/* <Button
                    size="large"
                    href= {item.href}
                    endIcon={
                      <svg
                        width={16}
                        height={16}
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17 8l4 4m0 0l-4 4m4-4H3"
                        />
                      </svg>
                    }
                  >
                    Learn More
                  </Button> */}
                </Box>
              </Box>
            </Box>
            </a>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Features;
